import React from 'react';
import './tournament-stats-styles.css';

type ChartData = {
  hour: number;
  participants: number;
};

const TournamentPlayersPerDayChart: React.FC<{
  chartData: ChartData[];
}> = ({ chartData }) => {
  if (!chartData) return <div>No data</div>;

  const formatDate = (hour: number) => {
    return `${hour}:00 - ${hour + 1}:00`;
  };

  return (
    <div
      id="participants-by-time-of-day-chart"
      className="d-flex justify-content-between align-items-center flex-row flex-wrap"
    >
      {chartData.map((data) => {
        return (
          <div
            className="d-flex flex-column justify-content-center align-items-center p-2"
            style={{ width: '12.5%', height: '100px' }}
          >
            <div
              className="d-flex flex-column justify-content-center align-items-center w-100 h-100 gap-2"
              style={{
                backgroundColor: `rgba(159, 70, 211, ${(data.participants === 0 ? 0 : data.participants / 30) + 0.035})`,
                borderRadius: '10px',
              }}
            >
              <p className="m-0">{formatDate(data.hour)}</p>
              <p className="m-0">Participants: {data.participants}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default TournamentPlayersPerDayChart;
